/**
 * Movies – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Movies menu icon. */
export default function MoviesIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width || 24 * Screen.widthRatio}`}
      height={`${height || 27 * Screen.widthRatio}`}
      viewBox={'0 0 24 27'}
      fill='none'
    >
      <path
        d='M22.5391 11.6091V23.3591C22.5388 24.4635 21.6435 25.3591 20.5391 25.3591H4.24316C3.13875 25.3591 2.24341 24.4635 2.24316 23.3591V11.6091H22.5391Z'
        stroke={color}
        strokeWidth={focused ? 2.5 : 2}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
      <path
        d='M3.12906 5.39737L19.0465 1.66324C20.1219 1.41097 21.1802 2.08224 21.4104 3.16257L21.844 5.19795L2.03222 9.84564L1.59863 7.81026C1.36849 6.72993 2.05369 5.64964 3.12906 5.39737Z'
        stroke={color}
        strokeWidth={focused ? 2.5 : 2}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
